import {
    CANDIDATE_OVERVIEW_UPDATE_REQUEST,
    CANDIDATE_OVERVIEW_UPDATE_SUCCESS,
    CANDIDATE_OVERVIEW_UPDATE_FAIL,
} from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

const baseUrl = process.env.REACT_APP_API_PATH

export const CandidateOverviewAction = (data) => {
    return function (dispatch) {
      dispatch({
        type: CANDIDATE_OVERVIEW_UPDATE_REQUEST,
        payload: true,
      });
   
      let OPTION = {
        url: `${baseUrl}/ebench/update_Candidate`,
        method: "PUT",
        data: data,
        headers: {
          "content-type": "application/json",
        },
      };
  
      axios(OPTION)
        .then((res) => {
          dispatch(updateDashboardContentPre(res.data));
          // window.location.href = "/candidate_dashboard";
        })
        .catch((error) => {
          dispatch({
            type: CANDIDATE_OVERVIEW_UPDATE_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
          toast.error("Failed To Update The DashboardContent!");
        });
    };
  };
  export const updateDashboardContentPre = (data) => {
    toast.success("Updated Successfully!");
    return {
      type: CANDIDATE_OVERVIEW_UPDATE_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };